import * as mobx from 'mobx'

export const communication = mobx.observable({
    isInProgress: false
})

export const blog = mobx.observable({
    posts: []
})

export const homeData = mobx.observable({
    data: {
        welcome: {
            title: '',
            text: ''
        },
        references: [],
        employes: [],
        contact: {
            name: '',
            address: '',
            email: '',
            phone: '',
            fax: ''
        }

        /* {
            fooldal: {
                title: '',
                body: ''
            },
            referencia: [],
            munkatars: [],
            elerhetoseg: {
                name: '',
                address: '',
                email: '',
                phone: '',
                fax: ''
            }*/
    }
})

mobx.autorun(() => {
    console.log('communicationInProgress: ' + communication.isInProgress)
})


// WEBPACK FOOTER //
// ./src/modules/store.js